module.exports = __webpack_public_path__ + "img/pota-ad.bf30ee8d.png";